/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Login_Resetpasswordsent2Inputs */



/**

* @param {_Login_Resetpasswordsent2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _login_resetpasswordsent2 = /** @type {((inputs?: _Login_Resetpasswordsent2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Login_Resetpasswordsent2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Sie erhalten in den nächsten Minuten eine E-Mail!")
});
export { _login_resetpasswordsent2 as "_login_resetPasswordSent" }